import React, {useState, useEffect} from "react";

import {API_ENDPOINT} from 'components/config/Common'
import Checkbox from 'components/ui/checkbox/checkbox.tsx'
import Radio from 'components/ui/radio/radio.tsx';
import Button from 'components/ui/Button.tsx'
import {CloseIcon} from 'components/custom-icons'
import {isBrowser} from "react-device-detect"


const GenderFilter = (props) => {

   //const [brands, setBrands] = useState(null)
   //const [brand_id, setBrand_id] =  useState(null)

   const [gender, setGender] =  useState(null)
   useEffect(() => {
      
   },[])

   

   const handleChange = (e) => {
      //console.log('onchange', e.target.name, e.target.value)
      setGender(e.target.value)
      //setValue([...value, e.target.value])
      //console.log('onchange', value)
      props.handleGenderFilter(e.target.value)
      if(isBrowser){
         setTimeout(() => {
            window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
            });
         }, 10);
      }
   }

   const clearBrandFilter = () => {
      let radio = document.getElementById(gender);
      radio.checked = false;
      props.handleGenderFilter(null) ;
   }

   

   return(
      <div className="h-full w-full bg-light dark:bg-gray-700 p-5">
         <div className="flex items-center justify-between">
            <div className="dark:text-zinc-400 uppercase">Gender</div>
            <Button 
               size='smaller'
               variant='normal'
               onClick={clearBrandFilter}
            >
            <CloseIcon className="w-4 h-4 pt-0.5 mr-0.5" /> Clear
            </Button>
         </div>
         <ul class="text-xs" >
          
            <li class="rounded-md py-1" key="">
               <div class="flex w-full items-center py-2 font-semibold text-body-dark outline-none transition-all ease-in-expo  focus:text-accent focus:outline-none focus:ring-0 ltr:text-left rtl:text-right text-body-dark text-sm text-body dark:text-zinc-400">
                
                  <Radio
                     name='gender'
                     label="Male"
                     id="male"
                     value="male"
                     className="mr-2"
                     onChange={handleChange}
                  />
                  
               </div>
            </li>
             <li class="rounded-md py-1" key="">
               <div class="flex w-full items-center py-2 font-semibold text-body-dark outline-none transition-all ease-in-expo  focus:text-accent focus:outline-none focus:ring-0 ltr:text-left rtl:text-right text-body-dark text-sm text-body dark:text-zinc-400">
                
                  
                  <Radio
                     name='gender'
                     label="FeMale"
                     id="female"
                     value="female"
                     className="mr-2"
                     onChange={handleChange}
                  />
                 
               </div>
            </li>
             <li class="rounded-md py-1" key="">
               <div class="flex w-full items-center py-2 font-semibold text-body-dark outline-none transition-all ease-in-expo  focus:text-accent focus:outline-none focus:ring-0 ltr:text-left rtl:text-right text-body-dark text-sm text-body dark:text-zinc-400">
                
                
                  <Radio
                     name='gender'
                     label="Non Binary"
                     id="non-binary"
                     value="non-binary"
                     className="mr-2"
                     onChange={handleChange}
                  />
               </div>
            </li>
           
         </ul>

         
      </div>
   )
}

export default GenderFilter